/* @flow */

export const ActionTypes = {
    ATTRIBUTION_MODAL_CLOSED: 'ATTRIBUTION_MODAL_CLOSED',
    ATTRIBUTION_MODAL_OPENED: 'ATTRIBUTION_MODAL_OPENED',
};

type AttributionModalClosedAction = {type: 'ATTRIBUTION_MODAL_CLOSED'};
type AttributionModalOpenedAction = {
    type: 'ATTRIBUTION_MODAL_OPENED',
};

export type AttributionModalAction = AttributionModalOpenedAction | AttributionModalClosedAction;

/*
 * Action creators
 */
export const closeAttributionModal = (): AttributionModalClosedAction => ({
    type: ActionTypes.ATTRIBUTION_MODAL_CLOSED,
});

export const openAttributionModal = (): AttributionModalOpenedAction => ({
    type: ActionTypes.ATTRIBUTION_MODAL_OPENED,
});
